import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import {
  FiCode,
  FiEdit,
  FiHome,
  FiSettings,
  FiShield,
  FiSliders,
  FiUploadCloud,
} from 'react-icons/fi';
import {
  Box,
  NavigationMenu,
  NavigationMenuGroup,
} from '..';
import { NavigationMenuItem } from '../NavigationMenu';
import {
  getFeatures,
  getCarrier,
} from '../../modules/selectors';

const propTypes = {
  features: PropTypes.shape({
    customContent: PropTypes.bool,
    forms: PropTypes.bool,
    plans: PropTypes.bool,
    theme: PropTypes.bool,
    staticFiles: PropTypes.bool,
  }).isRequired,
  width: PropTypes.string.isRequired,
  offset: PropTypes.string.isRequired,
  carrier: PropTypes.shape({ carrierId: PropTypes.number }),
};
const defaultProps = {
  carrier: null,
};

const SideBar = styled.div`
  height: calc(100vh - ${props => props.offset});
  width: ${props => props.width};
  position: fixed;
  top: ${props => props.offset};
  background-color: ${props => props.theme.backgroundColor_page};
  border-right: 1px solid ${props => props.theme.borderColor};
`;

const SpacedText = styled.span`
  padding-left: ${props => props.theme.space_inline_sm};
`;

const BuildVersion = styled.div`
 position: absolute;
 bottom: 0;
 left: 0;
 width: inherit;
 padding: 0 0 1em ${props => props.theme.space_inline_sm};
 & > span {
  font-weight: bolder;
  padding-right:0.3em;
 }
`;

// TODO this should only be displayed if an Admin is logged in
function AppSideBar({
  carrier: { carrierId }, features, width, offset,
}) {
  return (
    <SideBar width={width} offset={offset}>
      <Box height="1.5em" />
      <NavigationMenu>
        <NavigationMenuItem href="/" large>
          <FiHome />
          <SpacedText>Home</SpacedText>
        </NavigationMenuItem>
        {carrierId && features.forms && (
          <NavigationMenuGroup icon={<FiEdit />} title="Forms" href={`/carriers/${carrierId}/forms`}>
            <NavigationMenuItem href={`/carriers/${carrierId}/forms`}>All Forms</NavigationMenuItem>
          </NavigationMenuGroup>
        )}
        {carrierId && features.plans && (
          <NavigationMenuGroup icon={<FiShield />} title="Plans" href={`/carriers/${carrierId}/plans`}>
            <NavigationMenuItem href={`/carriers/${carrierId}/plans`}>All Plans</NavigationMenuItem>
            <NavigationMenuItem href={`/carriers/${carrierId}/plans/regions`}>Regions</NavigationMenuItem>
          </NavigationMenuGroup>
        )}
        {carrierId && features.customContent && (
          <NavigationMenuItem href={`/carriers/${carrierId}/contents`} large>
            <FiCode />
            <SpacedText>Custom Content</SpacedText>
          </NavigationMenuItem>
        )}
        {carrierId && features.staticFiles && (
          <NavigationMenuItem href={`/carriers/${carrierId}/staticFiles`} large>
            <FiUploadCloud />
            <SpacedText>Static Files</SpacedText>
          </NavigationMenuItem>
        )}
        {/* TODO - consider moving all pages (or admin only pages) to /admin/*  */}
        {carrierId && (
        <NavigationMenuGroup icon={<FiSliders />} title="Features" href={`/carriers/${carrierId}/features/bestige`}>
          <NavigationMenuItem href={`/carriers/${carrierId}/features/bestige`}>Bestige Features</NavigationMenuItem>
          <NavigationMenuItem href={`/carriers/${carrierId}/features/aqe`}>AQE Features</NavigationMenuItem>
        </NavigationMenuGroup>
        )}
        <NavigationMenuGroup icon={<FiSettings />} title="Settings" href="/settings/carriers">
          <NavigationMenuItem href="/settings/carriers">Carriers</NavigationMenuItem>
          <NavigationMenuItem href="/settings/clients">Clients</NavigationMenuItem>
          <NavigationMenuItem href="/settings/supportedLanguage">Language</NavigationMenuItem>
          <NavigationMenuItem href="/settings/resize">Resize</NavigationMenuItem>
          <NavigationMenuItem href="/settings/redesign">Redesign</NavigationMenuItem>
          {features.theme && <NavigationMenuItem href={`/carriers/${carrierId}/settings/theme`}>Theme</NavigationMenuItem>}
        </NavigationMenuGroup>
      </NavigationMenu>
    </SideBar>
  );
}
function mapStateToProps(state) {
  return {
    features: getFeatures(state),
    carrier: getCarrier(state),
  };
}
AppSideBar.propTypes = propTypes;
AppSideBar.defaultProps = defaultProps;

// Need to rerender on location update so that NavigationLinks can rerender
// and correctly highlight based on the route
export default withRouter(connect(mapStateToProps)(AppSideBar));
